import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ButtonLink from '../ButtonLink';
import SafeHTML from '../SafeHTML';
import CustomPropTypes from '../../utils/customPropTypes';
import { Dropdown } from 'semantic-ui-react'
import style from '../../../scss/components/Applications/ApplicationCategorySelector';
import 'semantic-ui-css/components/transition.min.css';
import 'semantic-ui-css/components/dropdown.min.css';
import 'semantic-ui-css/components/input.min.css';
import 'semantic-ui-css/components/form.min.css';
import ImageBlock from '../ImageBlock';
import scrollToElement from 'scroll-to-element';

export default class ApplicationCategorySelector extends React.Component {
    static propTypes = {
        eyebrow: PropTypes.string,
        selectorTitle: PropTypes.string,
        description: PropTypes.string,
        allCategories: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string,
            icon: CustomPropTypes.Image
        })),
        isCompactMode: PropTypes.bool
    }
    constructor(props) {
        super(props);

        this.state = {
            selectedCategory: this.props.selectedCategory,
            isDropdownOpened:false
        };
    }
    getClassname = (suffix = '') => {
        let cls = "application-category-selector" + `${suffix}`;
        if (this.props.isCompactMode) {
            cls = cls + ` compact`
        }
        return cls;
    }
    getCategoriesForDropdown = () => {
        const categoryOptions = [];
        var parentPage = document.querySelector('body').getAttribute('parent-page');
        if (parentPage) {
            var [url, title] = parentPage.split(';');
        }
        this.props.allCategories.map((data, index) => {
            console.log("data in appcatselect", data);
            let parentValue = data.parent_category == null ? null : data.parent_category
            if( parentValue && (parentValue.toLowerCase() === title.toLowerCase())){
                categoryOptions.push({
                    key: data.slug,
                    text: <span className="dropdown-item"><i className="chooser-icon"><ImageBlock image={data.icon} addWrapper={false} /></i>{data.name}</span>,
                    value: data.slug
                })
            }
            else if(parentValue === null){
                categoryOptions.push({
                    key: data.slug,
                    text: <span className="dropdown-item"><i className="chooser-icon"><ImageBlock image={data.icon} addWrapper={false} /></i>{data.name}</span>,
                    value: data.slug
                })
            }
        })
        return categoryOptions;
    }
    getGoToParentLink = () => {
        var parentPage = document.querySelector('body').getAttribute('parent-page');
        if (parentPage) {
            var [url, title] = parentPage.split(';');
            return <div className="has-back-link">
                <div className="container"><a href={url} className="btn btn-link-normal btn-back-link">
                    <i className="icon icon-prev"></i>&nbsp;{title}
                </a></div>
            </div>
        }
        return null;
    }
    handleChange = (e, { value }) => {
        this.setState({ selectedCategory: value });
        var elm = document.querySelector('.application-category-selector');
        var parentPage = document.querySelector('body').getAttribute('parent-page');
        var [url, title] = parentPage.split(';');
        console.log("url issues", url, "hxbsjhxbsxsq",  window.location.href);
        var appLandingPage = this.props.isCompactMode ? url : window.location.href;
        window.location.href = appLandingPage + value.toLowerCase();
    }
    handleDropdownOpen = () =>{
this.setState({isDropdownOpened:true});
    }
    handleDropdownClose = () =>{
        this.setState({isDropdownOpened:false});
    }
    render() {
        return (
            <>
                <section className={this.getClassname()}>
                    {this.getGoToParentLink()}
                    <div className="container banner-wrapper">
                        {(this.props.eyebrow || this.props.description) && <div className="banner-content">
                            {this.props.eyebrow && <h1 className="banner-main-title">{this.props.eyebrow}</h1>}

                            {this.props.description && <div className="banner-desc">
                                <SafeHTML>
                                    {this.props.description}
                                </SafeHTML>
                            </div>}
                        </div>}
                        <div className={"dropdown-selector" + (this.state.isDropdownOpened ? " opened" : " closed")}>
                            <h2 className="dropdown-label" >{this.props.selectorTitle}</h2>
                            <Dropdown name="category"
                                options={this.getCategoriesForDropdown()}
                                onChange={this.handleChange}
                                onOpen={this.handleDropdownOpen}
                                onClose={this.handleDropdownClose}
                                placeholder='category.'
                                selection
                                selectOnBlur={false}
                                value={this.state.selectedCategory} />
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
